import SovetskiyRayon from './coordinates/Bryansk/Sovetskiy rayon g. Bryanska.json';
import BezhickiyRayon from './coordinates/Bryansk/Bezhickiy rayon.json';
import VolodarskiyRayon from './coordinates/Bryansk/Volodarskiy rayon.json';
import FokinskiyRayon from './coordinates/Bryansk/Fokinskiy rayon g. Bryanska.json';
import BelieBerega from './coordinates/Bryansk/pgt belie Berega.json';
import BeloberezhskiySanatoriy from './coordinates/Bryansk/p. Beloberezhskiy sanatoriy.json';
import SanatoriySnezhka from './coordinates/Bryansk/Sanatoriy Snezhka.json';
import BolishoePolpino from './coordinates/Bryansk/P. Bolishoe Polpino.json';
import Oktyabriskiy from './coordinates/Bryansk/p. Oktyabriskiy.json';
import Putevka from './coordinates/Bryansk/Bryanskiy rayon Bryanskoy oblasti p. Putevka.json';
import Kuzimino from './coordinates/Bryansk/Bryanskiy rayon Bryanskoy oblasti p. Kuzimino.json';
import MaloeKuzimino from './coordinates/Bryansk/p. Maloe Kuzimino Bryansk obl.json';
import Suponevo from './coordinates/Bryansk/p. Suponevo.json';
import RadicaKrilovka from './coordinates/Bryansk/r.p. Radica-Krilovka.json';
import Chaykovichi from './coordinates/Bryansk/p. Chaykovichi.json';
import Rassvet from './coordinates/Bryansk/SO Rassvet.json';
import kottedzhniyPoselokRay from './coordinates/Bryansk/kottedzhniy poselok Ray.json';
import poselokAntonovka from './coordinates/Bryansk/poselok Antonovka.json';
import Bezhichi from './coordinates/Bryansk/Rayon Bezhichi.json';
import OtradnenskoeSeliskoePoselenie from './coordinates/Bryansk/Otradnenskoe seliskoe poselenie.json';
import sadovodcheskoeObshtestvoMichurinec from './coordinates/Bryansk/sadovodcheskoe obshtestvo Michurinec.json';
import poselokBordovichi from './coordinates/Bryansk/poselok Bordovichi.json';
import uchebniyAerodromBezhica from './coordinates/Bryansk/uchebniy aerodrom Bezhica.json';
import VokzaliniyMikrorayon from './coordinates/Bryansk/Vokzaliniy mikrorayon.json';

export default {
    regionCode: 'bryansk',
    serviceAreas: [
        {
            id: 'bryansk-1',
            include: [
                {
                    name: 'Советский район',
                    type: 'polygon',
                    coordinates: SovetskiyRayon,
                },
            ],
        },
        {
            id: 'bryansk-2',
            include: [
                {
                    name: 'Бежицкий район',
                    type: 'polygon',
                    coordinates: BezhickiyRayon,
                },
                {
                    name: 'Володарский район',
                    type: 'polygon',
                    coordinates: VolodarskiyRayon,
                },
                {
                    name: 'Фокинский район',
                    type: 'polygon',
                    coordinates: FokinskiyRayon,
                },
            ],
            exclude: [
                {
                    name: 'пгт белые Берега',
                    type: 'polygon',
                    coordinates: BelieBerega,
                },
                {
                    name: 'п. Белобережский санаторий',
                    type: 'polygon',
                    coordinates: BeloberezhskiySanatoriy,
                },
                {
                    name: 'п. Санаторий Снежка',
                    type: 'polygon',
                    coordinates: SanatoriySnezhka,
                },
                {
                    name: 'п. Большое Полпино',
                    type: 'polygon',
                    coordinates: BolishoePolpino,
                },
                {
                    name: 'п. Октябрьский',
                    type: 'polygon',
                    coordinates: Oktyabriskiy,
                },
                {
                    name: 'р.п. Радица-Крыловка',
                    type: 'polygon',
                    coordinates: RadicaKrilovka,
                },
                {
                    name: 'п. Чайковичи',
                    type: 'polygon',
                    coordinates: Chaykovichi,
                },
                {
                    name: 'СО Рассвет',
                    type: 'polygon',
                    coordinates: Rassvet,
                },
                {
                    name: 'коттеджный поселок Рай',
                    type: 'polygon',
                    coordinates: kottedzhniyPoselokRay,
                },
                {
                    name: 'посёлок Антоновка',
                    type: 'polygon',
                    coordinates: poselokAntonovka,
                },
                {
                    name: 'Район Бежичи',
                    type: 'polygon',
                    coordinates: Bezhichi,
                },
                {
                    name: 'Отрадненское сельское поселение',
                    type: 'polygon',
                    coordinates: OtradnenskoeSeliskoePoselenie,
                },
                {
                    name: 'Садоводческое общество Мичуринец',
                    type: 'polygon',
                    coordinates: sadovodcheskoeObshtestvoMichurinec,
                },
                {
                    name: 'поселок Бордовичи',
                    type: 'polygon',
                    coordinates: poselokBordovichi,
                },
                {
                    name: 'учебный аэродром Бежица',
                    type: 'polygon',
                    coordinates: uchebniyAerodromBezhica,
                },
                {
                    name: 'Вокзальный микрорайон',
                    type: 'polygon',
                    coordinates: VokzaliniyMikrorayon,
                },
            ],
        },
        {
            id: 'bryansk-3',
            include: [
                {
                    name: 'п. Путевка',
                    type: 'polygon',
                    coordinates: Putevka,
                },
                {
                    name: 'п. Кузьмино',
                    type: 'polygon',
                    coordinates: Kuzimino,
                },
                {
                    name: 'п. Малое Кузьмино',
                    type: 'polygon',
                    coordinates: MaloeKuzimino,
                },
                {
                    name: 'п. Супонево',
                    type: 'polygon',
                    coordinates: Suponevo,
                },
            ],
        },
    ]
};

